import './rxjs-extensions';

import { NgModule } from '@angular/core';
import { FormsModule }  from '@angular/forms';
import { CommonModule } from '@angular/common';

import { FileComponent } from './file.component';
import { FileRoutingModule } from './file.routing.module';

import { GenericdatasetService } from '../../services/genericdataset/genericdataset.service';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    FileRoutingModule,
  ],
  exports: [
    FileComponent
  ],
  declarations: [
    FileComponent
  ],
  providers: [
    GenericdatasetService
  ],
})
export class FileModule { }
